import { HashRouter, Route, Routes } from 'react-router-dom';
import { LearningProvider } from './context/LearningContext';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ChapterPage } from './pages/ChapterPage';

export default function App() {
  return <LearningProvider><HashRouter><Routes><Route element={<Layout />}><Route index element={<HomePage />} /><Route path="chapter/:slug" element={<ChapterPage />} /><Route path="*" element={<HomePage />} /></Route></Routes></HashRouter></LearningProvider>;
}
